<template>
  <div>
    <section role="form">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <card-header titulo="Avaliações de Estágios Probatórios" />
                <div>
                  <table-loader :carregando="carregando">
                    <div
                      class="alert alert-warning"
                      role="alert"
                      style="text-align: center"
                      v-if="anosAvaliados.length == 0"
                    >
                      <i class="fa fa-flag-o fa-lg"></i>&nbsp; Ainda não foram
                      geradas avaliações para o seu registro.
                    </div>
                    <table class="table table-striped table-hover" v-else>
                      <thead>
                        <tr>
                          <th>Avaliação</th>
                          <th v-if="ehAvaliador">Minha Avaliação</th>
                          <th v-else>Avaliação</th>
                          <th v-if="ehAvaliador" class="hidden-xs">
                            Avaliados Pendentes
                          </th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="avaliacao in avaliacoesOrdenadas"
                          :key="avaliacao.id"
                          :class="statusDaLinhaDaTabela(avaliacao)"
                        >
                          <td>{{ avaliacao.mes + '/'+  avaliacao.ano }}</td>
                          <td>
                            {{ statusDaAvaliacao(avaliacao) }}
                          </td>
                          <td v-if="ehAvaliador" class="hidden-xs">
                            {{ quantidadeDeAvaliacoesPorAvaliador(avaliacao) }}
                          </td>
                          <td class="td-btns td-btns-alone">
                            <div v-if="ehAvaliador">
                              <botao
                                :estilo="statusDoBotao(avaliacao)"
                                icone="editar-tabela"
                                @clicado="
                                  editaAvaliacao(funcionario.id, avaliacao)
                                "
                                v-show="
                                  condicionalDoBotaoDeAvaliador(avaliacao)
                                "
                                v-tooltip.left="'Editar'"
                              ></botao>
                              <botao
                                estilo="vazado-cinza-sm"
                                icone="visualizar"
                                @clicado="
                                  editaAvaliacao(funcionario.id, avaliacao)
                                "
                                v-show="
                                  !condicionalDoBotaoDeAvaliador(avaliacao)
                                "
                                v-tooltip.left="'Visualizar'"
                              ></botao>
                            </div>
                            <div v-else>
                              <botao
                                :estilo="statusDoBotao(avaliacao)"
                                icone="editar-tabela"
                                @clicado="
                                  editaAvaliacao(funcionario.id, avaliacao)
                                "
                                v-show="
                                  condicionalDoBotaoComum(avaliacao, true)
                                "
                                v-tooltip.left="'Editar'"
                              ></botao>
                              <botao
                                estilo="vazado-cinza-sm"
                                icone="visualizar"
                                @clicado="
                                  editaAvaliacao(funcionario.id, avaliacao)
                                "
                                v-show="
                                  condicionalDoBotaoComum(avaliacao, false)
                                "
                                v-tooltip.left="'Visualizar'"
                              ></botao>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </table-loader>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import CardHeader from '@/components/card-header';
import TableLoader from '@/components/table-loader';
import AvaliacoesEstagioProbatorioService from '@/services/avaliacoesEstagioProbatorioService';
import AvaliadorEstagioProbatorioService from '@/services/avaliadorEstagioProbatorioService';
import PeriodosEstagioProbatorioService from '@/services/periodosEstagioProbatorioService';
import ErrorHelper from '@/helpers/ErrorHelper';
import moment from 'moment';

export default {
  name: 'AvaliacaoEstagioProbatorio',

  data() {
    return {
      apiErrors: null,
      funcionario: this.$store.state.funcionario,
      carregando: false,
      anosAvaliados: [],
      periodos: [],
      anos: [],
      periodoAvaliacaoAnoAtual: {},
      avaliador: {},
    };
  },
  computed: {
    avaliacoesOrdenadas() {
      return this.anosAvaliados.sort((a, b) => b.ano - a.ano || a.mes - b.mes);
    },
    ehAvaliador() {
      return this.avaliador ? this.avaliador.totalPendente != null : false;
    },
    usuarioAtual() {
      return this.$store.state.funcionario;
    },
  },
  watch: {
    usuarioAtual(novo, anterior) {
      this.funcionario = novo;
      this.editaRegistro(this.funcionario.id);
    },
  },
  methods: {
    statusDaLinhaDaTabela(avaliacao) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];
      const { aceita } = avaliacao;

      return this.validaEhEditavel(avaliacao, dataInicioLancamento, dataFimLancamento)
        ? 'situacao-pendente'
        : '';
    },
    statusDaAvaliacao(avaliacao) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];

      const ehEditavel = this.validaEhEditavel(
        avaliacao,
        dataInicioLancamento,
        dataFimLancamento,
      );

      const periodoAindaNaoAbriu = new Date() < new Date(dataInicioLancamento);
      if (avaliacao.idAvaliacaoAvaliador == null && avaliacao.idAvaliador == this.usuarioAtual.id) return '-';
      if (ehEditavel) return 'EM ANDAMENTO';
      if (periodoAindaNaoAbriu) return 'INDISPONÍVEL';
      return 'FINALIZADA';
    },
    quantidadeDeAvaliacoesPorAvaliador(avaliacao) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];

      return this.situacaoAvaliacoesPendentes(
        dataInicioLancamento,
        dataFimLancamento,
        avaliacao,
      )
        ? avaliacao.totalPendente
        : 'NENHUM';
    },
    statusDoBotao(avaliacao) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];
      const { aceita } = avaliacao;

      return this.validaEhEditavel(avaliacao, dataInicioLancamento, dataFimLancamento) &&
        aceita == null
        ? 'vazado-laranja-sm'
        : 'vazado-cinza-sm';
    },
    condicionalDoBotaoDeAvaliador(avaliacao) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];

      return this.validaEhEditavel(
        avaliacao,
        dataInicioLancamento,
        dataFimLancamento);
    },
    condicionalDoBotaoComum(avaliacao, status) {
      const { dataInicioLancamento, dataFimLancamento } = avaliacao.periodos[0];

      const ehEditavel = this.validaEhEditavel(
        avaliacao,
        dataInicioLancamento,
        dataFimLancamento,
      );

      if (status) {
        return ehEditavel;
      }

      return !ehEditavel;
    },
    validaEhEditavel(avaliacao, dataInicial, dataFinal) {
      const { aceita } = avaliacao;

      if (dataInicial && dataFinal) {
        const periodoAberto = moment(new Date()).isBetween(dataInicial, dataFinal, 'day', '[]');
        const naoHaAceite = aceita == null;
        const avaliadoresPendentes = avaliacao.totalPendente > 0;

        return periodoAberto && naoHaAceite;
      }

      return false;
    },
    validaPeriodoAindaNaoAbriu(avaliacao) {
      const { dataInicioLancamento } = avaliacao.periodos[0];

      const periodoAindaNaoAbriu = new Date() < new Date(dataInicioLancamento);

      if (periodoAindaNaoAbriu) {
        const erro = new Error('O período de avaliação ainda não está aberto');
        erro.type = 'warning';
        throw erro;
      }
    },
    situacaoAvaliacoesPendentes(dataInicial, dataFinal, avaliacao) {
      if (dataInicial && dataFinal && avaliacao) {
        return (
          moment(new Date()).isBetween(dataInicial, dataFinal, 'day', '[]') 
          && avaliacao.totalPendente > 0
        );
      }
      return false;
    },
    apagaDuplicatas(array) {
      let arrayLimpo = [];
      array.forEach(element => {
        if (!arrayLimpo.some(item => item.id === element.id)) {
          arrayLimpo.push(element);
        }
      });

      return arrayLimpo;
    },
    async editaRegistro(funcionarioId) {
      this.carregando = true;
      try {
        const anosAvaliados = await AvaliacoesEstagioProbatorioService.lista(funcionarioId);

        if (!anosAvaliados.length) {
          this.anosAvaliados = anosAvaliados;
          this.carregando = false;
          return;
        }

        this.anosAvaliados = await this.obtemAnosAvaliadosComTotalPendente(anosAvaliados);
        this.periodoAvaliacaoAnoAtual = this.avaliacoesOrdenadas[0];

        this.obtemContagemAvaliados(
          funcionarioId,
          this.periodoAvaliacaoAnoAtual.id,
        );
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregando = false;
      }

    },   
    async obtemContagemAvaliados(funcionarioId, idMes) {
      this.carregando = true;

      try {
        const avaliador = await AvaliadorEstagioProbatorioService.lista(funcionarioId, idMes);

        this.avaliador = avaliador;
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        if (mensagem === 'Recurso não encontrado') {
          this.avaliador.totalPendente = null;
          return;
        }
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregando = false;
      }
    },
    async obtemAnosAvaliadosComTotalPendente(anosAvaliados) {
      let anos = [];

      let anosAvaliadosAgrupados = this.apagaDuplicatas(anosAvaliados);

      for (let ano of anosAvaliadosAgrupados) {
        const total = await AvaliadorEstagioProbatorioService.lista(this.funcionario.id, ano.id);
        ano.totalPendente = total.totalPendente;
        anos.push(ano);
      }

      return anos;
    },     
    async editaAvaliacao(id, avaliacao) {
      try {
        this.validaPeriodoAindaNaoAbriu(avaliacao);

        const periodos = await this.obtemPeriodos(id, avaliacao);

        if(this.usuarioAtualEhAvaliador(periodos)) {
          this.redirecionaParaAvaliados();
          return;
        }
        this.redirecionaParaDetalheAvaliacao(id);

      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);

        if (error.type === 'warning') {
          this.$root.$refs.toastr.w(mensagem, 'Atenção');
          return;
        }

        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    async obtemPeriodos(id, avaliacao) {
      const periodos = await PeriodosEstagioProbatorioService.lista(id, avaliacao.id);
      this.periodos = periodos;
      sessionStorage.setItem('periodosEstagioProbatorio', JSON.stringify(this.periodos));
      return periodos;
    },
    usuarioAtualEhAvaliador(periodos) {
      const avaliador = periodos.find(periodo =>
        periodo.avaliado.id !== this.funcionario.id &&
          (periodo.avaliador.id === this.funcionario.id ||
           periodo.segundoAvaliador.id === this.funcionario.id));

      return avaliador != null;
    },
    redirecionaParaAvaliados() {
      this.$router.push({
        name: 'AvaliadosEstagioProbatorio',
        params: { idAvaliador: this.funcionario.id },
      });
    },
    redirecionaParaDetalheAvaliacao(id) {
      this.$router.push({
        name: 'DetalhaAvaliacaoEstagioProbatorio',
        params: {
          idAvaliador: this.funcionario.id,
          idAvaliado: id,
        },
      });
    }
  },
  created() {
    this.editaRegistro(this.funcionario.id);
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  components: {
    Botao,
    CardHeader,
    TableLoader,
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?9996f622